import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

import type { SnackbarOrigin } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { ExpandLess } from '@material-ui/icons';
import { Close } from '@material-ui/icons';
import Icon from 'bz-icons/src/controls/icon';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import styles from './styles';

import { IconButton, Paper, Snackbar } from '@material-ui/core';

interface IProps extends WithStyles<typeof styles> {
  confirmation: boolean;
}

@observer
class IOSAddToHomeScreen extends React.Component<IProps> {
  static readonly iOSRegex: RegExp = /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i;
  static readonly defaultProps: Partial<IProps> = {
    confirmation: false
  };

  @observable open: boolean = true;

  constructor(props: IProps) {
    super(props);

    if (props.confirmation) {
      this.open = true;
    } else {
      const cookies = document.cookie.split(';');
      this.open = !cookies.some((cookie) => {
        return cookie.trim() === 'hideAddToHomeScreenPrompt=true';
      });
    }
  }

  render() {
    if (!this.show) return null;

    const { classes } = this.props;

    return (
      <Snackbar
        open={this.open}
        onClose={this.onClose}
        anchorOrigin={this.position}
        autoHideDuration={30000}
      >
        <Paper className={classes.grid}>
          <p className={classes.text}>
            Tap <Icon value="0128_upload_load_share" height="18" width="18" /> then select Add to
            Home Screen for quick access to this site.
          </p>
          <ExpandLess fontSize="large" className={classes.upArrow} />
          <ExpandMore fontSize="large" className={classes.downArrow} />
          <IconButton size="small" color="inherit" onClick={this.onClose} className={classes.close}>
            <Close />
          </IconButton>
        </Paper>
      </Snackbar>
    );
  }

  private get position(): SnackbarOrigin {
    if (screen.width > 767) {
      return { vertical: 'top', horizontal: 'right' };
    }
    return { vertical: 'bottom', horizontal: 'center' };
  }

  @computed
  private get show(): boolean {
    if (window.navigator.standalone) {
      return false;
    }

    if (window.location.pathname.startsWith('/join')) {
      return false;
    }

    if (!IOSAddToHomeScreen.iOSRegex.test(navigator.userAgent)) {
      return false;
    }

    const cookies = document.cookie.split(';');
    return cookies.some((cookie) => {
      return cookie.trim() === 'connectGdprConsent=true';
    });
  }

  @action.bound
  private onClose(): void {
    document.cookie = 'hideAddToHomeScreenPrompt=true;max-age=7890000';
    this.open = false;
  }
}

export default withStyles(styles)(IOSAddToHomeScreen);
